import { useState, useEffect } from 'react';

export function usePWA() {
    const [installPrompt, setInstallPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        // Detectar iOS
        const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

        setIsIOS(isIOSDevice && !isStandalone);

        const handler = (e) => {
            // Impedir que o Chrome 76+ mostre o prompt automático
            e.preventDefault();
            // Salvar o evento para ser disparado depois
            setInstallPrompt(e);
            setIsInstallable(true);
            console.log('PWA: Prompt de instalação capturado');
        };

        window.addEventListener('beforeinstallprompt', handler);

        // Verificar se já está instalado
        if (isStandalone) {
            setIsInstallable(false);
        }

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const installApp = async () => {
        if (isIOS) {
            alert('Para instalar no iPhone:\n1. Clique no botão de Compartilhar (quadrado com seta)\n2. Role para baixo e clique em "Adicionar à Tela de Início"');
            return;
        }

        if (!installPrompt) return;

        // Mostrar o prompt nativo
        installPrompt.prompt();

        // Aguardar a resposta do usuário
        const { outcome } = await installPrompt.userChoice;
        console.log(`PWA: Usuário escolheu ${outcome}`);

        // Limpar o prompt (ele só pode ser usado uma vez)
        setInstallPrompt(null);
        setIsInstallable(false);
    };

    return { isInstallable: isInstallable || isIOS, installApp, isIOS };
}
